import { createContext, useContext } from 'react';

import { type ConfirmProps, type FilteredFiles, type ModalProps, type UploadFile } from './types';

interface UploadContextType {
  confirmProps: ConfirmProps | null;
  filteredFiles: FilteredFiles;
  modalProps: ModalProps | null;
  modalVisible: boolean;
  selectedFiles: UploadFile[];
  setConfirmProps: React.Dispatch<React.SetStateAction<ConfirmProps | null>>;
  setFilteredFiles: React.Dispatch<React.SetStateAction<FilteredFiles>>;
  setModalProps: React.Dispatch<React.SetStateAction<ModalProps | null>>;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedFiles: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  setUploading: React.Dispatch<React.SetStateAction<boolean>>;
  uploading: boolean;
  validFiles: UploadFile[];
  setCorruptImgFiles: React.Dispatch<React.SetStateAction<string[]>>;
  corruptImgFiles: string[];
  showDragAndDropDirectoryError: boolean;
  setShowDragAndDropDirectoryError: React.Dispatch<React.SetStateAction<boolean>>;
}

export const defaultUploadContext: UploadContextType = {
  confirmProps: null,
  filteredFiles: { count: 0, status: false },
  modalProps: null,
  modalVisible: false,
  selectedFiles: [],
  setConfirmProps: () => {},
  setFilteredFiles: () => {},
  setModalProps: () => {},
  setModalVisible: () => {},
  setSelectedFiles: () => {},
  setUploading: () => {},
  uploading: false,
  validFiles: [],
  setCorruptImgFiles: () => {},
  corruptImgFiles: [],
  showDragAndDropDirectoryError: false,
  setShowDragAndDropDirectoryError: () => {},
};

export const UploadContext = createContext<UploadContextType>(defaultUploadContext);

export function useUploadContext() {
  return useContext(UploadContext);
}
